import getTenant from './getTenant';
import { assets } from '../data';
const env = process.env.REACT_APP_S3_ENV || 'production';
const deployment = process.env.REACT_APP_DEPLOYMENT || null;

const getLogoSrc = ({ variant } = {}) => {
  if (deployment === 'onprem') {
    return variant
      ? `./static/logos/headerlogo-${variant}.png`
      : `./static/logos/headerlogo.png`;
  }
  if (window.location.host.startsWith('aml')) {
    return assets['aml-headerlogo.svg'];
  }
  return variant
    ? `https://s3.eu-west-2.amazonaws.com/vinciworks-customer-assets/${env}/client/${getTenant()}/omnitrack/headerlogo-${variant}.png`
    : `https://s3.eu-west-2.amazonaws.com/vinciworks-customer-assets/${env}/client/${getTenant()}/omnitrack/headerlogo.png`;
};

export default getLogoSrc;
